import React from 'react'
import CustomToolTip from '../../../../CommonComponents/CustomToolTip'
import { get_navigator_button_by_dashboard } from './utils'
import { DeploymentType } from '../../../types'

interface PlanningNavigationProps {
    deploymentType: DeploymentType
    activeTab: string | undefined
    onNavigate: (tabName: string) => void
}

const PlanningNavigation: React.FC<PlanningNavigationProps> = ({ deploymentType, activeTab, onNavigate }) => {
    return (
        <div className='planning__header__left__container'>
            {get_navigator_button_by_dashboard(deploymentType).map((btn) => {
                const Icon = btn.icon
                return (
                    <CustomToolTip
                        key={btn.name}
                        title={btn.label}
                        placement='top'
                    >
                            <button
                            type="button"
                            className={`header__navigation__button ${activeTab === btn.name ? 'active' : ''}`}
                            onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
                                e.stopPropagation()
                                onNavigate(btn.name)
                            }}
                        >
                            <div className='button__icon'> <Icon /></div>
                            <span className='button__label'>{btn.label}</span>
                        </button>
                    </CustomToolTip>
                )
            })}
        </div>
    )
}

export default PlanningNavigation
